<template>
	<Modals :title="titleModal" :display="display" @show="closeModal">
		<template #modal-content>
			<div class="schedule-stop-move">
				<div class="schedule-stop-move__primary" v-if="isStopSchedule">
					<div class="schedule-stop-move__head">
						<div class="schedule-stop-move__head-date">
							Moving on
							{{ shortDateString(dataSchedule.scheduledDate) }}
						</div>
						<div class="schedule-stop-move__head-hour">
							6:30 AM EST
						</div>
					</div>

					<div class="schedule-stop-move__tags">
						<span>{{ moveToProdTagMessage }} </span>

						<span> {{ releaseTypeTagMessage }}</span>
					</div>

					<div class="schedule-stop-move__comment">
						{{ dataSchedule.comment }}
					</div>

					<div class="schedule-stop-move__clients">
						{{ listOfCustomers }}
					</div>
				</div>

				<div class="schedule-stop-move__secondary" v-else>
					<div class="schedule-stop-move__text">
						Your action would remove all customers from the
						schedule.
					</div>
					<div class="schedule-stop-move__text">
						To keep a schedule active, it must have at least one
						customer included. If you wish to proceed, please
						provide a reason why this schedule is no longer needed.
					</div>
				</div>

				<Textarea
					label="Why are you stopping the schedule?"
					:maxLength="200"
					:rows="4"
					v-model="dataSchedule.actionComment"
					:required="true"
					:showErrorMessage="false"
					@input="setActionComment"
				/>
			</div>
		</template>
		<template #modal-footer>
			<ButtonGroup>
				<template #container>
					<span class="schedule-stop-move__stop-btn">
						<Button
							id="stopButtonModal"
							className="btn--caution"
							:labelText="submitTitleBtn"
							type="submit"
							:btnClick="stopAction"
							:disabled="hasError"
						/>
						<Tooltip
							class="schedule-stop-move__stop-btn-tooltip"
							:text="actionCommentErrorMessage"
							:display="actionCommentErrorMessage != ''"
						/>
					</span>
					<Button
						id="cancelButtonModal"
						className="btn--link"
						labelText="Cancel"
						:btnClick="closeModal"
						data-testid="cancel-btn"
					/>
				</template>
			</ButtonGroup>
		</template>
	</Modals>
</template>

<script>
import Modals from '@/components/shells/modal/modals';
import Button from '@/components/forms/button/button';
import ButtonGroup from '@/components/forms/button/button-group';
import Textarea from '@/components/forms/textarea/textarea.vue';
import { mapGetters, mapActions } from 'vuex';
import { required } from 'vuelidate/lib/validators';
import DatetimeMixin from '@/mixins/datetime-mixin';
import Tooltip from '@/components/shells/tooltip/tooltip';
//vue
import { mapState } from 'vuex';
import _ from 'lodash';
export default {
	name: 'EnvironmentScheduleStopModal',
	mixins: [DatetimeMixin],
	components: {
		Modals,
		Button,
		ButtonGroup,
		Textarea,
		Tooltip
	},
	model: {
		prop: 'display',
		event: 'show'
	},
	props: {
		display: {
			type: Boolean,
			default: false
		},
		schedule: {
			type: Object,
			default: () => {}
		},
		isStopSchedule: {
			type: Boolean,
			default: false
		},
		titleModal: {
			type: String
		}
	},
	data() {
		return {
			dataSchedule: {}
		};
	},
	validations: {
		dataSchedule: {
			actionComment: {
				required
			}
		}
	},
	computed: {
		...mapGetters('customers', ['customerById']),
		...mapState('options', ['OptionsEnvironments']),

		submitTitleBtn() {
			return this.isStopSchedule
				? 'Stop Scheduled Move'
				: 'Remove All Clients and Stop the Schedule';
		},
		listOfCustomers() {
			const customers = this.dataSchedule.customers || [];
			if (customers.length > 0) {
				const customerNames = customers.map(
					customer => customer.customerName
				);
				return customerNames.join(', ');
			} else {
				return '';
			}
		},
		hasError() {
			return this.$v.$invalid;
		},
		moveToProdTagMessage() {
			if (!_.isEmpty(this['OptionsEnvironments'])) {
				const environment = this['OptionsEnvironments'].find(
					env =>
						parseInt(env.value) === this.dataSchedule.moveToZoneId
				);
				if (!_.isEmpty(environment)) {
					return `Move to ${environment.description}`;
				}
			}
			return '';
		},
		releaseTypeTagMessage() {
			const state = {
				H: 'Hotfix',
				R: 'Release'
			};
			return state[this.dataSchedule.releaseType];
		},
		actionCommentErrorMessage() {
			if (this.$v.dataSchedule.actionComment.$dirty) {
				if (!this.$v.dataSchedule.actionComment.required) {
					return 'Complete required fields to proceed.';
				} else {
					return '';
				}
			} else {
				return '';
			}
		}
	},

	methods: {
		...mapActions('environments', {
			updateScheduleAction: 'saveSchedule'
		}),
		closeModal() {
			this.dataSchedule = {};
			this.$v.$reset();
			this.$emit('show', false);
		},
		async stopAction() {
			const mapCustomers = propName => {
				return this.dataSchedule[propName].map(item => {
					return {
						customerId: item.value
					};
				});
			};

			let payload = _.omit(this.dataSchedule, [
				'removedCustomers',
				'customers'
			]);
			const customers = mapCustomers('customers');

			Object.assign(payload, {
				customers: customers
			});
			payload.status = 'STOPPED';

			await this.updateScheduleAction(payload);

			this.dataSchedule = {};
			this.closeModal();
			this.$emit('reload', true);
			this.$emit('showAlert', true);
		},
		setActionComment() {
			this.$v.dataSchedule.actionComment.$touch();
		}
	},
	watch: {
		display: {
			immediate: true,
			handler(val) {
				if (val) {
					let scheduleCopy = _.cloneDeep(this.schedule);
					const today = new Date();
					//validate schedule Date greater than today
					if (new Date(scheduleCopy.scheduledDate) < today) {
						const tomorrow = new Date(
							today.setDate(today.getDate() + 1)
						);
						Object.assign(scheduleCopy, {
							scheduledDate: tomorrow
						});
					}
					this.dataSchedule = scheduleCopy;
				}
			}
		}
	}
};
</script>

<style lang="scss" scoped>
::v-deep .modal {
	@include mq($from: md) {
		width: 540px;
	}
}
::v-deep .modal__body {
	overflow: initial;
}

.schedule-stop-move {
	display: flex;
	flex-direction: column;
	gap: $gutter-lg;
	@include body-text('regular');

	&__primary,
	&__secondary {
		display: flex;
		flex-direction: column;
		gap: $gutter-lg;
	}

	&__head-date {
		@include heading('md');
	}

	&__head-hour {
		text-transform: uppercase;
	}

	&__tags {
		display: flex;
		gap: $gutter-md;
	}

	/* CSS added to fix popper's styles not applying */

	&__stop-btn {
		position: relative;
	}

	&__stop-btn-tooltip {
		@include vertical-center-with-transform;
		top: -36px;
	}
}
</style>
